import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";

import ButtonPrimary from "../Buttons/ButtonPrimary";
import { requiredField } from "../../validation/formValidation";

const DocumentExplanationModal = ({ documento, onSubmit, onCancel }) => {
  return (
    <div className="mx-auto">
      <Formik initialValues={{ explicacao: documento.explicacao ?? null }} onSubmit={onSubmit}>
        {({ values, isValid, handleChange, handleBlur }) => (
          <Form className="form-group">
            <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-4">
              <h4>Adicione uma explicação para o documento:</h4>
              <p className="font-weight-bold">{documento.nome}</p>
            </div>
            <div className="form-group">
              <Field
                type="text"
                name="explicacao"
                id="explicacao"
                component="textarea"
                className="form-control my-3"
                placeholder="Explicação"
                rows="3"
                validate={requiredField}
                value={values.explicacao}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage
                name="explicacao"
                component="small"
                className="form-text text-danger"
              />
            </div>
            <div className='d-flex justify-content-center gap-1 w-full mt-2'>
              <ButtonPrimary className="btn-cancel swal2-styled" onClick={onCancel}>
                Cancelar
              </ButtonPrimary>
              <ButtonPrimary className="btn-confirm swal2-styled" type="submit" disabled={!isValid}>
                Salvar
              </ButtonPrimary>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default DocumentExplanationModal;
